module.exports = __webpack_public_path__ + "img/expand.d28c7289.svg";